import type { ShoppingCart } from '@optionway/models';

interface SearchPricingStore {
  result?: ShoppingCart;
}

export const useSearchPricingStore = defineStore('search-pricing', {
  state: (): SearchPricingStore => ({
    result: undefined,
  }),
  actions: {
    // An offer has just been priced: prebook, bags, insurance, payment result, promotion code and contribution
    // restart from this cart, so no entry point forgets a step. Passengers follow the criteria: reconciled.
    applyPricing(result: ShoppingCart) {
      // First: the passenger sync below drops the per-pax bags the removals have to report.
      useGtmStore().trackCartCleared();
      this.result = result;
      useSearchPrebookStore().$reset();
      useSelectedOfferStore().$reset();
      usePassengersStore().syncWithCriteria();
      useLuggagesStore().reset();
      usePaymentResultStore().$reset();
      useSelectedInsuranceStore().$reset();
      useSelectedContributionStore().$reset();
      useDiscountStore().$reset();
    },
  },
});
